<template>
    <div
        class="base-image"
        :class="className"
        >
        <div :style="{ paddingTop: aspectRatio * 100 + '%' }">
            <Transition name="base-image__transition">
                <img
                    v-show="sourceLoaded"
                    key="img"
                    :style="{ objectFit }"
                    class="base-image__img"
                    :alt="alt"
                    :src="lazy ? lazySrc : src"
                    @load.once="onSourceLoaded"
                    >
            </Transition>

            <img
                v-if="!lazySrc && !src"
                key="placeholder"
                class="base-image__placeholder"
                :src="placeholder"
                >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: [Object, String],
        },
        placeholder: {
            type: String,
            default: '/images/img-placeholder.svg',
        },
        objectFit: String,
        lazy: {
            type: Boolean,
            default: true,
        },
        aspectRatio: Number,
    },

    data () {
        return {
            imageData: {
            },
            sourceLoaded: false,
            lazySrc: '',
        }
    },

    computed: {
        className () {
            return {
                '-object-fit': this.objectFit,
                '-aspect-ratio': this.aspectRatio,
            }
        },
        alt () {
            return this.imageData ? this.imageData.alt || this.imageData.title || '' : ''
        },
        src () {
            return this.imageData && this.imageData.src ? this.imageData.src : this.placeholder
        },
    },

    watch: {
        image () {
            this.setImageData()
            this.bindSrc()
        },
    },

    methods: {
        onSourceLoaded () {
            this.sourceLoaded = true
        },
        bindSrc () {
            this.lazySrc = this.src
        },
        initObserver () {
            const observer = new IntersectionObserver(changes => {
                for (let i = 0; i < changes.length; i++) {
                    const change = changes[i];
                    if (change.isIntersecting) {
                        this.bindSrc()
                        observer.unobserve(this.$el)
                    }
                }
            })


            observer.observe(this.$el)
        },
        setImageData () {
            this.imageData = typeof this.image === 'string' ? { src: this.image } : this.image
        },
    },

    created () {
        this.setImageData()
    },

    mounted () {
        if (this.lazy) {
            this.initObserver()
        }
    },
}
</script>

<style lang="scss">
.base-image {

    > div {
        width: 100%;
        height: 100%;
    }

    img {
        max-width: 100%;
    }

    &__placeholder {
        position: absolute;
        top: 0;
        left: 0;
        width: 100% !important;
        height: 100% !important;
    }
}

.base-image.-object-fit {
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
    }
}

.base-image.-aspect-ratio {
    overflow: hidden;

    > div {
        position: relative;
        display: block;
    }

    img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
}

.base-image__transition-enter-active, .base-image__transition-leave-active {
    transition: opacity .2s !important;
}

.base-image__transition-enter, .base-image__transition-leave-to {
    opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/base/BaseImage.vue